define('lq/events/actions/csvExportCommand',[
    'lq/events/actions/eventAction',
    'jquery',
    'lq',
    'lq/cookie',
    'lq/formSubmission'
], function (EventAction, $, lq, cookie, FormSubmission) {
    'use strict';

    function CsvExportCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(CsvExportCommand, EventAction);

    CsvExportCommand.typeName = 'CsvExportCommand';

    CsvExportCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    CsvExportCommand.prototype.createEventActionRequest = function() {
        if (this.eventData.downloadOnly)
            return undefined;

        return {
            eventActionType: 'CsvExport',
            command: this.eventData.command
        };
    };

    CsvExportCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (this.eventData.downloadOnly) {
            var token = 'csv-export-' + Date.now();

            var form = new FormSubmission(this.piping.url.prepare(lq.getTenantUrl('Export/Csv')));
            form.addProperty('actionId', this.piping.actionId);
            form.addProperty('csvExportId', this.eventData.command);
            form.addProperty('token', token);
            form.addParameters('parameters', this.piping.parameters.getNonSystemParameters());
            form.submit();

            var waitWhileDownloadIsStarting = function () {
                if (cookie.get(token) === null)
                    setTimeout(waitWhileDownloadIsStarting, 200);
                else
                    continuation();
            };
            waitWhileDownloadIsStarting();
        } else if (eventActionResponse.download) {
            window.location.href = this.piping.url.prepare(lq.getTenantUrl('DynamicContent/DownloadFile'), {
                url: eventActionResponse.url,
                filename: eventActionResponse.filename,
                openInBrowser: false
            });
            continuation();
        } else {
            continuation();
        }
    };

    return CsvExportCommand;
});
